import * as yup from "core/hookForm/yup";
import i18n from "core/i18n";

import { CampaignEmailSourceEnum } from "types/enums";

import { CampaignElCommunicationFormValues } from "./types/CampaignElCommunicationFormValues";

export default function () {
    const { t } = i18n.useTranslation();

    const validationSchema: yup.ObjectSchema<CampaignElCommunicationFormValues> = yup.object({
        guid: yup.string().required(),
        idObject: yup.number().required(),
        campaignEmailSource: yup
            .mixed<CampaignEmailSourceEnum>()
            .oneOf(Object.values(CampaignEmailSourceEnum))
            .required(t("error.required")),
        agreement: yup.boolean().oneOf([true], t("error.required")).required(t("error.required")),
    });

    return validationSchema;
}
